// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"384":"81e53873","969":"614dbd0a"}[chunkId] + ".chunk.css";
};